// 🔑 THIS BUNDLE'S RELEASE NUMBER, SENT AS X-Client-Build ON EVERY REQUEST (Jesse, 2026-10-18). The server treats a
// native app (ios/android) with no build or one older than its MIN_NATIVE_CLIENT_RELEASE as a legacy client and tells
// it to update (backend/constants/clientRelease.js). Raise it — never lower it — in a release that changes what the
// server requires of the app; test/clientRelease holds the two in step.
export const CLIENT_RELEASE = 2026101801;
